import { fetchJson } from "src/utils/apiUtils";
import {
  IRemyndScrapeCategoryMappingPreviewReq,
  IRemyndScrapeCategoryMappingPreviewResp,
  IRemyndScrapeCategoryMappingRuleBatchStoreReq,
  IRemyndScrapeCategoryMappingRuleFullData,
  IRemyndScrapeCategoryMappingUpdateReq
} from "./types";

const endpoint = `master/remyndScrapeCategoryMappingRule`;

export const listFullData = async () => {
  return fetchJson<IResponse<IRemyndScrapeCategoryMappingRuleFullData>>(
    `${endpoint}/listFullData`,
    { method: "GET" }
  );
};

export const batchStore = async (
  req: IRemyndScrapeCategoryMappingRuleBatchStoreReq
) => {
  return fetchJson<IResponse<RemyndBrandPartnerMapId>>(
    `${endpoint}/batchStore`,
    {
      method: "POST",
      body: JSON.stringify({ ...req })
    }
  );
};

export const processPreview = async (
  req: IRemyndScrapeCategoryMappingPreviewReq
) => {
  return fetchJson<IResponse<IRemyndScrapeCategoryMappingPreviewResp>>(
    `${endpoint}/processPreview`,
    {
      method: "POST",
      body: JSON.stringify({ ...req })
    }
  );
};

export const processUpdate = async (
  req: IRemyndScrapeCategoryMappingUpdateReq
) => {
  return fetchJson<IResponse<Int>>(`${endpoint}/processUpdate`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};
